/* 🤖 this file was generated by svg-to-ts */
export const kzIconsChange: {
  name: 'change';
  data: string;
} = {
  name: 'change',
  data: `<svg viewBox="0 0 16 17"><g stroke="currentColor" stroke-width="1.35" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M14.725 9.556c-.434 3.507-3.404 6.222-7.004 6.222-3.898 0-7.059-3.184-7.059-7.111 0-3.928 3.16-7.111 7.059-7.111a7.046 7.046 0 0 1 6.114 3.554"/><path d="M13.897.667v4.525H9.405"/></g></svg>`
};
